import * as React from 'react';
import { Prompt } from 'react-router';
import { Card } from 'material-ui/Card';
import { get } from 'lodash';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import remote from '@inqool/uas-web-core/es/components/controls/remote';
import { compose, withProps } from 'recompose';
import { reduxForm } from 'redux-form';
import { Input, InputField, AutoCompleteField, AutoComplete, InlineGridField, InlineGrid } from '@components/form';

import * as T from '@modules/hr-workPositions/_workPositionsTypes';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';
import { getWorkPosition } from '@modules/hr-workPositions/_workPositionsActions';
import { required } from '@utils/validators';
import columns from '@modules/hr-workPositions/_workPositionsColumns';
import { workPositionType } from '@modules/hr-workPositions/_workPositionsEnum';
import { WorkPositionsReplacementsForm } from '@modules/hr-workPositions/WorkPositionsReplacementsForm';

const linkBack = '/hr/work-positions';

const enhance = compose<T.WorkPositionsFormProps, T.WorkPositionsFormProps>(
  EntityDetailEnhancer<T.WorkPositionsEnhancerProps<T.WorkPosition>, T.WorkPosition>({
    getEntity: getWorkPosition,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Pracovní pozice', to: linkBack },
    { label: get(entity, 'name', 'Nová pozice') }
  ]),
  withProps<{}, T.WorkPositionsForm>(({ entity }) => ({
    initialValues: get(entity, 'id') ? entity : {},
    url: '/metropolis/api/hr/work-positions',
    id: get(entity, 'id', '')
  })),
  remote,
  withProps(({ id, items }) => ({
    items: items.filter(o => get(o, 'id') !== id)
  })),
  reduxForm({
    form: 'work-positions-form'
  })
);

const View: React.SFC<any> = ({ change, items, closeItem, ...props }) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={4}>
              <InputField component={Input} name="name" label="Název pozice *" validate={[required]} />
            </Col>
            <Col md={4}>
              <AutoCompleteField
                component={AutoComplete}
                name="supervisor"
                label="Nadřízený"
                items={items}
                labelFunction={o => get(o, 'name')}
              />
            </Col>
            <Col md={4}>
              <AutoCompleteField
                component={AutoComplete}
                name="type"
                label="Typ pozice *"
                items={workPositionType}
                labelFunction={o => get(o, 'label')}
                valueFunction={o => get(o, 'id')}
                validate={[required]}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <h4>Náhradníci</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InlineGridField
                component={InlineGrid}
                name="replacements"
                columns={columns}
                Form={WorkPositionsReplacementsForm}
                showCheckboxes={true}
                adding={true}
                editing={false}
                deleting={true}
              />
            </Col>
          </Row>
        </Grid>

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const WorkPositionsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-workPositions/WorkPositionsForm.tsx